module.exports = __webpack_public_path__ + "assets/smart-asset-website-icon.801a2dce.svg";